import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "dialog-footer" }


import { ref, defineComponent, onMounted } from 'vue'
import { apiFetchData, getI18n, isEmptyArray } from '../utils'

const __default__ = defineComponent({
  name: 'WarningDlg',
  components: {
  }
})

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const refData = ref([])
const refIsVisible = ref(false)

const queryWarning = async () => {
  const data = await apiFetchData('/action?__action_id=pl_query_warning')
  refData.value = data.data
  refIsVisible.value = !isEmptyArray(refData.value)
  // console.log('refIsVisible.value=', refIsVisible.value, Date.now() / 1000)
}
onMounted(async () => {
  queryWarning()

  setInterval(() => {
    queryWarning()
  }, 1000 * 60 * 10)
})
function onOk () {
  refData.value = []
  refIsVisible.value = false
}

return (_ctx: any,_cache: any) => {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (refIsVisible.value)
    ? (_openBlock(), _createBlock(_component_el_dialog, {
        key: 0,
        modelValue: refIsVisible.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((refIsVisible).value = $event)),
        title: _unref(getI18n)('警告'),
        width: 800,
        draggable: true,
        "close-on-click-modal": false
      }, {
        footer: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (onOk()))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(getI18n)('关闭')), 1)
              ]),
              _: 1
            })
          ])
        ]),
        default: _withCtx(() => [
          _createVNode(_component_el_table, {
            data: refData.value,
            border: "",
            style: {"width":"100%"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_table_column, {
                prop: "warning_type",
                label: _unref(getI18n)('类型'),
                width: "80"
              }, null, 8, ["label"]),
              _createVNode(_component_el_table_column, {
                prop: "content",
                label: _unref(getI18n)('内容')
              }, null, 8, ["label"]),
              _createVNode(_component_el_table_column, {
                prop: "created_at",
                label: _unref(getI18n)('产生时间'),
                width: "200"
              }, null, 8, ["label"])
            ]),
            _: 1
          }, 8, ["data"])
        ]),
        _: 1
      }, 8, ["modelValue", "title"]))
    : _createCommentVNode("", true)
}
}

})